import api from "@/api/settings/settings";

const getAdminSettings = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getAdminSettings(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
});

const updateAdminSettings = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .updateAdminSettings(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
});

const getLanguages = () =>
  new Promise((resolve, reject) => {
    api
      .getLanguages()
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
});

export default {
  getAdminSettings,
  updateAdminSettings,
  getLanguages
};
